import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/demos/')({
  component: () => <Navigate to="/demos/component-showcase" />,
});
